// extracted by mini-css-extract-plugin
export default {"ReportBugModal":"ReportBugModal__i0zeZ"};